/* the dashboard's document cards link here with one of these, named and
   coloured as the card is (ink, amber, green, red); the menu's Document status
   chips show and set them */
export const CARD_FILTERS = [
  { key: 'is_uploaded', label: 'Uploaded', color: 'neutral' },
  { key: 'is_sorted', label: 'Sorted', color: 'warning' },
  { key: 'is_consolidated', label: 'Consolidated', color: 'success' },
  { key: 'is_unknown', label: 'Unknown', color: 'danger' },
] as const;

/* `search` is not one of them: the explorer's own search box owns it, so the
   filters' badge and Reset leave it alone */
export const FILTER_KEYS = [
  'contract_type_ids',
  'collection_date_start',
  'collection_date_end',
  'contract_date_start',
  'contract_date_end',
  'document_type',
  'amendment_date_start',
  'amendment_date_end',
  ...CARD_FILTERS.map(({ key }) => key),
] as const;

export const DOCUMENT_TYPES = [
  { value: 'application/msword', label: 'Microsoft Word (.doc)' },
  {
    value:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    label: 'Microsoft Word (.docx)',
  },
  { value: 'application/pdf', label: 'PDF' },
  { value: 'text/plain', label: 'Text' },
];
